import { Component, OnInit, Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, Router } from '@angular/router';
import { EnvService } from 'src/app/env-services/env.service';

@Injectable()
export class AuthGuard implements CanActivate {

  orderId: any = '';

  constructor(private env: EnvService, private route: Router) {

  }

  canActivate() {
    
    let currUrl = window.location.origin;
    if (currUrl != this.env.billtypeBaseUrl.IUS.URL)
      return true;
    if (currUrl == this.env.billtypeBaseUrl.IUS.URL && (window.location.hash.includes('#/ius?oid') || window.location.hash.includes('#/thankyou'))) {
      return true;
    } else {
      return false;
    }
  }
}


